var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$route.name !== "ClaimsEdit" &&
    _vm.$route.name !== "ContractCreate" &&
    _vm.$route.name !== "ContractEdit" &&
    _vm.$route.name !== "CompanyRatings"
    ? _c(
        "div",
        {
          staticClass: "l-content container-fluid",
          class: [_vm.backgroundGray, _vm.noOverflow]
        },
        [_c("router-view")],
        1
      )
    : _c("div", { staticClass: "l-content" }, [_c("router-view")], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fda6c28c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fda6c28c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/LayoutContent.vue
// module id = null
// module chunks = 